import { Popover, Portal } from "@chakra-ui/react";

import { TagSelectList } from "../tag-select-list";
import { TagOptionType } from "../tag-select-list/types";

import { EditableTagToggle } from "./editable-tag-toggle";

type EditableTagProps<T extends string> = {
  name: string;
  description?: string;
  placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
  value?: T | null;
  options?: TagOptionType<T>[];

  onChangeValue?: (value: T) => void;
};

export const EditableTag = <T extends string>({
  placement = "bottom-start",
  name,
  description,
  value,
  options = [],
  onChangeValue,
}: EditableTagProps<T>) => {
  const selectedOption = options.find(option => value === option.value);

  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      positioning={{ placement, offset: { crossAxis: 0, mainAxis: 8 } }}
    >
      <Popover.Trigger asChild>
        <EditableTagToggle selectedOption={selectedOption} />
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <TagSelectList
              name={name}
              description={description}
              value={value}
              options={options}
              onChangeValue={onChangeValue}
            />
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
